import { VenueType, VenueTypeCode } from '../features/landing/constants/venueTypes';

interface VenueTypeColorScheme {
  primary: string;
  light: string;
  dark: string;
  bg: string;
  gradient: string;
  glow: string;
}

export const venueTypeColors: Record<VenueTypeCode, VenueTypeColorScheme> = {
  [VenueType.GAMING]: {
    primary: '#A855F7',      // Boosted purple (was #8B5CF6)
    light: '#C084FC',
    dark: '#9333EA',
    bg: 'rgba(168, 85, 247, 0.12)',
    gradient: 'linear-gradient(135deg, #A855F7 0%, #9333EA 100%)',
    glow: '0 0 40px rgba(168, 85, 247, 0.3)',
  },
  [VenueType.SNOOKER]: {
    primary: '#10B981',      // Boosted green (was #059669)
    light: '#34D399',
    dark: '#059669',
    bg: 'rgba(16, 185, 129, 0.12)',
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
    glow: '0 0 40px rgba(16, 185, 129, 0.3)',
  },
  [VenueType.KIDS_PLAYAREA]: {
    primary: '#FB923C',      // Boosted orange (was #F59E0B)
    light: '#FDBA74',
    dark: '#EA580C',
    bg: 'rgba(251, 146, 60, 0.12)',
    gradient: 'linear-gradient(135deg, #FB923C 0%, #EA580C 100%)',
    glow: '0 0 40px rgba(251, 146, 60, 0.3)',
  },
};

export function getVenueTypeColor(venueType: VenueTypeCode): VenueTypeColorScheme {
  return venueTypeColors[venueType as VenueTypeCode] || venueTypeColors[VenueType.GAMING];
}
